import React from 'react';
import './ImageEffectSelector.css';

const imageEffects = [
    { id: 'none', name: 'None', preview: '🖼️' },
    { id: 'blur', name: 'Blur', preview: '🌫️' },
    { id: 'blur-light', name: 'Light Blur', preview: '💨' },
    { id: 'blur-heavy', name: 'Heavy Blur', preview: '🌪️' },
    { id: 'grayscale', name: 'Grayscale', preview: '⚫' },
    { id: 'top-fade', name: 'Top Fade', preview: '🔝' },
    { id: 'bottom-fade', name: 'Bottom Fade', preview: '🔻' },
    { id: 'left-fade', name: 'Left Fade', preview: '◀️' },
    { id: 'right-fade', name: 'Right Fade', preview: '▶️' },
    { id: 'center-glow', name: 'Center Glow', preview: '⭕' },
    { id: 'dark-vignette', name: 'Dark Vignette', preview: '🌑' },
    { id: 'light-vignette', name: 'Light Vignette', preview: '💡' }
];

function EffectSelector({ effects, selectedEffect, onEffectChange, label, columns = 4 }) {
    return (
        <div className="effect-selector-container">
            <label className="effect-selector-label">{label}</label>
            <div className="effect-selector-grid" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
                {effects.map((effect) => (
                    <button
                        key={effect.id}
                        type="button"
                        className={`effect-selector-button ${selectedEffect === effect.id ? 'selected' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onEffectChange(effect.id);
                        }}
                        title={effect.name}
                    >
                        <div className="effect-preview">
                            <span className="effect-preview-symbol">{effect.preview}</span>
                        </div>
                        <span className="effect-name">{effect.name}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}

function ImageEffectSelector({ selectedEffect, onEffectChange }) {
    return (
        <EffectSelector
            effects={imageEffects}
            selectedEffect={selectedEffect}
            onEffectChange={onEffectChange}
            label="Image Effect"
            columns={4}
        />
    );
}

export { ImageEffectSelector };
